import React from "react";
import { Box, Typography } from "@mui/material";

import OrdersOverview from "./orders/OrdersOverview";
import Orders from "./orders/Orders";
import PickersOverview from "./pickers/PickersOverview";

const OrderDashboard = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        pt: 0,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ fontSize: "18px", color: "#16151C", marginBottom: "20px" }}
      >
        SSS AUTO PARTS (QLD) PTY. LTD
      </Typography>
      <OrdersOverview />
      <Orders />
      <PickersOverview />
    </Box>
  );
};

export default OrderDashboard;
